import React from "react";
import "./advert.css";
import image2 from "../../assets/shop-img-2.png";

const Advert = () => {
  return (
    <div className="bg-light p-2">
      <div className="container">
        <div className="row advert">
          <div className="advert-item col-sm-6 d-flex align-items-center justify-content-center">
            <img src={image2} alt="advertImage" />
          </div>
          <div className="advert-item col-sm-6 d-flex align-items-center justif-content-center">
            <div className="text-center">
              <p>
                You never get tired! Enjoy shopping from where you sit, without
                ever coming to the store!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advert;
